import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import SellDeliveryNoteStatusBar, { SellDeliveryNoteStatusBarNew, SellDeliveryNoteStatusBarProps } from '../../../SellDeliveryNStatusBar'
import SellDeliveryNoteWaitingResponseStepButtons, { SellDeliveryNoteWaitingResponseStepButtonsNew } from '../SellDNWaitRespButtons'

type SellDeliveryNoteWaitingResponseStepHeaderProps = & SellDeliveryNoteStatusBarProps & OrderStepButtonsBaseComponentProps

const SellDeliveryNoteWaitingResponseStepHeaderDecider: React.FC<SellDeliveryNoteWaitingResponseStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={SellDeliveryNoteWaitingResponseStepHeaderDefault} NewComponent={SellDeliveryNoteWaitingResponseStepHeaderNew} {...rest} />
    )
}

const SellDeliveryNoteWaitingResponseStepHeaderDefault: React.FC<SellDeliveryNoteWaitingResponseStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <SellDeliveryNoteStatusBar {...rest} />
            <SellDeliveryNoteWaitingResponseStepButtons {...rest} />
        </div>
    )
}

const SellDeliveryNoteWaitingResponseStepHeaderNew: React.FC<SellDeliveryNoteWaitingResponseStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <SellDeliveryNoteStatusBarNew {...rest} />
            <SellDeliveryNoteWaitingResponseStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default SellDeliveryNoteWaitingResponseStepHeaderDecider